// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1LoFi","actions":"styles_actions__1iSjk","error":"styles_error__1tkKy","message":"styles_message__-2dXQ"};